/**
* Building Maps JS
* -----------------------------------------------------------------------------
*
* All the JS for the Building Maps component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'building-maps',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const sliders = $( '.building-maps.splide' );

      if ( sliders.length ) {
        sliders.each( function( index, slide ) {
          const splide = new Splide( slide, {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            pagination: false,
            drag: false,
            live: true,
          } ).mount();
          const currentSlide = $( slide ).find( '.current-slide' );

          $( slide ).find( '.total-slides' ).text( splide.length );

          splide.on( 'moved', function( newIndex ) {
            $( currentSlide ).text( newIndex + 1 );
          } );

          splide.on( 'overflow', function( isOverflow ) {
            splide.options = {
              arrows: isOverflow,
            };
          } );
        } );
      }

      // gsap.registerPlugin( ScrollTrigger );
      // $( '.building-maps .maps' ).slick( {
      //   arrows: false,
      //   dots: false,
      //   infinite: false,
      //   waitForAnimate: false,
      //   speed: 0,
      //   cssTransitions: false,
      //   draggable: false,
      // } );

      // $( '.building-maps .fake-slider-nav .slider-prev' ).click( function() {
      //   $( this ).closest( '.building-maps' ).find( '.maps' ).slick( 'slickPrev' );
      // } );

      // $( '.building-maps .fake-slider-nav .slider-next' ).click( function() {
      //   $( this ).closest( '.building-maps' ).find( '.maps' ).slick( 'slickNext' );
      // } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'building-maps', COMPONENT );
} )( app );
